// Local translations
export const T = {
  en_GB: {
    showStatistics: "Show Statistics",
    showStatisticsDesc: "Display expected return and volatility percentages",
    showTable: "Show Table",
    showTableDesc: "Display lower, expected, and upper value projections",
    compareWithBank: "Compare with bank savings",
    compareWithBankDesc:
      "Show a line for the same deposits at the collection's flat bank rate (rate set in the portfolio collection's calculation settings)",
  },
  nb_NO: {
    showStatistics: "Vis statistikk",
    showStatisticsDesc: "Vis forventet avkastning og volatilitetsprosenter",
    showTable: "Vis tabell",
    showTableDesc: "Vis nedre, forventede og øvre verdiprognoser",
    compareWithBank: "Sammenlign med banksparing",
    compareWithBankDesc:
      "Vis en linje for de samme innskuddene med samlingens flate bankrente (renten settes i porteføljesamlingens beregningsinnstillinger)",
  },
} as const;
